import type { UserDTO } from "@repo/types/dtos";
import { type ColumnConfig } from "@repo/types/ui/tables";

export const UserColumns = {
  id: {
    key: "UserGuid",
    label: "User Id",
  },
  FullName: {
    key: "FullName",
    label: "Name",
  },
  email: {
    key: "Email",
    label: "Email",
  },
  phoneNumber: {
    key: "PhoneNumber",
    label: "Phone",
  },
  userType: {
    key: "UserType",
    label: "User Type",
  },
  canAssignBookingRequest: {
    key: "CanAssignBookingRequest",
    label: "Booking Request",
  },
  createdOn: {
    key: "CreatedOn",
    label: "Created On",
  },
  createdBy: {
    key: "CreatedByUser",
    label: "Created By",
  },
  updatedOn: {
    key: "UpdatedOn",
    label: "Updated On",
  },
  updatedBy: {
    key: "UpdatedByUser",
    label: "Updated By",
  },
} satisfies Record<string, ColumnConfig<UserDTO>>;
